import React, { useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import LineHaulCompanies from "./_components/LineHaulCompanies";
import RequestsCompanies from "./_components/RequestsCompanies";

const LineHaulManagement: React.FC = () => {
  const [activeRole, setActiveRole] = useState("Company");
  const roles = ["Company", "Requests"];
  return (
    <div className="p-4 space-y-4">
      <h1 className="text-3xl text-[#212121] ">Line Haul Management</h1>
      <RoleToggle
        options={roles}
        active={activeRole}
        onChange={setActiveRole}
      />
      
      <div className="">
        {activeRole === "Company" && <LineHaulCompanies />}
        {activeRole === "Requests" && <RequestsCompanies />}
      </div>
    </div>
  );
};
export default LineHaulManagement;
